import { render, staticRenderFns } from "./StatsList.vue?vue&type=template&id=dee59260&"
import script from "./StatsList.vue?vue&type=script&lang=js&"
export * from "./StatsList.vue?vue&type=script&lang=js&"
import style0 from "./StatsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatsList.vue"
export default component.exports